import React from "react";
import { Link } from "react-router-dom";

const Reports = () => {
  return (
    <div className="page">
      <header className="page-header">
        <div>
          <h1 className="page-title">Reports</h1>
          <p className="page-subtitle">
            <Link to="/">Home</Link> / Reports
          </p>
        </div>
      </header>

      <section className="panel">
        <div className="section-heading">
          <div>
            <p className="eyebrow">Wealth</p>
            <h2>Balance sheet and passive income</h2>
          </div>
          <p className="section-copy">Reports centered on accumulated value and recurring income.</p>
        </div>
        <div className="dashboard-grid">
          <Link to="/ReportsDashboard" className="nav-card">
            Dashboard
            <small>High-level financial summary with net worth, averages, and category spend</small>
          </Link>
          <Link to="/ReportsPassiveIncome" className="nav-card">
            Passive Income
            <small>Annual and monthly interest income from bank balances</small>
          </Link>
          <Link to="/ReportsPassiveIncomeTracking" className="nav-card">
            Passive Income Tracking
            <small>Line chart of passive income by reporting period</small>
          </Link>
          <Link to="/ReportsNetWorth" className="nav-card">
            Net Worth Report
            <small>Line chart of net worth by reporting period</small>
          </Link>
          <Link to="/NetWorth" className="nav-card">
            Net Worth
            <small>Store and recompute net worth values by period</small>
          </Link>
        </div>
      </section>

      <section className="panel page-cta">
        <div className="section-heading">
          <div>
            <p className="eyebrow">Cash Flow</p>
            <h2>Income and spending analysis</h2>
          </div>
          <p className="section-copy">Use these when you want to understand movement over time and spending composition.</p>
        </div>
        <div className="dashboard-grid">
          <Link to="/ReportsIncomeExpenditureTracking" className="nav-card">
            Income, Expenditure Tracking
            <small>Line chart of total credits and total debits by reporting period</small>
          </Link>
          <Link to="/ReportsIncomeTrends" className="nav-card">
            Income Trends
            <small>Track income by income category over time</small>
          </Link>
          <Link to="/ReportsPeriodSummary" className="nav-card">
            Period Summary
            <small>Credits, debits and category expenditure by reporting period</small>
          </Link>
          <Link to="/ReportsSpendingTrends" className="nav-card">
            Spending Trends
            <small>Track category expenditure over time with one line chart per category</small>
          </Link>
          <Link to="/ReportsPeriodTransactions" className="nav-card">
            Period Transaction Summary
            <small>Subcategory expenditure for a selected reporting period</small>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Reports;
